import { QualificationsDto } from '@gtpl/shared-models/masters';
import {Injectable} from '@nestjs/common';
import { Qualifications } from '../qualifications.entity';
import { QualificationDTO } from './qualifications.dto';

@Injectable()
export class QualificationAdapter {
    
    public convertDtoToEntity(qualificaitonDTO: QualificationDTO, isUpdate: boolean = false) : Qualifications {
        const qualificaiton = new Qualifications();
        qualificaiton.qualificationId = qualificaitonDTO.qualificationId;
        qualificaiton.qualificationName = qualificaitonDTO.qualificationName;
        qualificaiton.isActive = qualificaitonDTO.isActive == undefined ? true : qualificaitonDTO.isActive;
        if(isUpdate){
            qualificaiton.updatedUser = qualificaitonDTO.updatedUser;
        } else {
            qualificaiton.isActive = true;
            qualificaiton.createdUser = qualificaitonDTO.createdUser;
        }
        return qualificaiton;
    }
    
    public convertEntityToDto(qualificationsObject: Qualifications) : QualificationDTO {
        const qualificationDTO= new QualificationDTO;
    qualificationDTO.qualificationId = qualificationsObject.qualificationId;
    qualificationDTO.qualificationName = qualificationsObject.qualificationName;
    qualificationDTO.isActive = qualificationsObject.isActive;
    qualificationDTO.createdAt = qualificationsObject.createdAt;
    qualificationDTO.updatedAt = qualificationsObject.updatedAt;
    qualificationDTO.createdUser = qualificationsObject.createdUser;
    qualificationDTO.updatedUser = qualificationsObject.updatedUser;
    qualificationDTO.versionFlag = qualificationsObject.versionFlag;
    return qualificationDTO; 
    }
}